'use client'

import { customerDashboardPath } from '@/lib/namedRoutes'

/**
 * Matches redesigned dashboard routes that mount `AccountDashboardShell`'s
 * side/bottom nav chrome. Blocked accounts render only a notice with no
 * dashboard chrome (see `AccountDashboardShell`), so callers pass
 * `isBlocked` to exclude them and keep their own nav visible.
 */
export function useIsAnyDashboardHomePage(pathname: string, isBlocked: boolean): boolean {
    if (pathname.startsWith('/account/medication-check-in')) {
        return false
    }

    const isAccountRoute = pathname === customerDashboardPath || pathname.startsWith(`${customerDashboardPath}/`)

    return isAccountRoute && !isBlocked
}
